import { TimePicker } from 'antd';
import styled from 'styled-components';

export const CustomTimePicker = styled(TimePicker)<{
  onChange?: any;
}>`
  &.ant-picker {
    border-color: ${({ theme }) => theme.colors.primary[100]} !important;
  }
  .ant-picker-suffix {
    color: ${({ theme }) => theme.colors.primary[100]} !important;
  }
  .ant-picker-input input::placeholder {
    color: #585858 !important;
  }
`;
